import React from 'react'
import { Grid } from '@mui/material'

import { LogoutButton } from './logout-button.tsx'
import { ProfileButton } from './profile-button.tsx'
import { useUser } from '@/stores/slices/user-slice.ts'

export const HeaderUserControls = (): React.ReactElement | null => {
  const user = useUser()

  if (!user) return null

  return (
    <>
      <Grid item sx={{ display: { xs: 'none', md: 'initial' } }}>
        <ProfileButton />
      </Grid>
      <Grid data-testid="button-logout-desktop" item sx={{ display: { xs: 'none', md: 'initial' } }}>
        <LogoutButton />
      </Grid>
    </>
  )
}
